import React from 'react';

const Logo = ({ size = 'default', showText = true }) => {
  const sizeClasses = {
    small: 'w-8 h-8',
    default: 'w-10 h-10',
    large: 'w-16 h-16'
  };

  const textSizeClasses = {
    small: 'text-lg',
    default: 'text-xl',
    large: 'text-2xl'
  };

  return (
    <div className="flex items-center gap-2">
      <div className={`${sizeClasses[size]} bg-gradient-to-br from-[#FFB4A2] to-[#F7DBA7] rounded-full flex items-center justify-center p-1 overflow-hidden`}>
        <img 
          src="https://customer-assets.emergentagent.com/job_footsmart-3/artifacts/mzt1zwjs_WhatsApp%20Image%202026-03-31%20at%2010.36.19.jpeg" 
          alt="FeetSmart-Ai Logo" 
          className="w-full h-full object-cover rounded-full"
        />
      </div>
      {showText && (
        <span className={`${textSizeClasses[size]} font-bold bg-gradient-to-r from-[#FFB4A2] via-[#F7DBA7] to-[#A8D5FF] bg-clip-text text-transparent`}>
          FeetSmart-Ai
        </span>
      )}
    </div>
  );
};

export default Logo;
